<template>
  <div>
    <header-component />
    <div class="container-fluid mt--6">
      <div class="card">
        <div class="card-header">
          <h3 class="mb-0" style="text-transform: capitalize">Chalans List</h3>
          <div class="text-right col-lg-12 col-5">
            <div class="table-filters">
              <el-tag
                v-for="(tag, index) in filters"
                :key="index"
                :disable-transitions="false"
                closable
                @close="removeFilter(index)"
              >
                <span v-if="tag">
                  {{ tag.field }}:
                  <span style="font-weight: bold">
                    {{ tag.value }}..
                    <span />
                  </span>
                </span>
              </el-tag>
            </div>
            <el-popover
              v-model="filterPopUpVisible"
              placement="left"
              width="550"
            >
              <table-filter @apply="applyFilters" />
              <base-button slot="reference" size="sm" type="primary"
                >Add Filter</base-button
              >
            </el-popover>
          </div>
        </div>
        <el-table
          :data="allChalans"
          style="width: 100%"
          header-row-class-name="thead-light"
        >
          <el-table-column label="Date" min-width="90">
            <template slot-scope="scope">{{
              scope.row.updatedAt | dateFormat
            }}</template>
          </el-table-column>
          <el-table-column
            label="Chalan No."
            prop="chalanNumber"
            min-width="90"
          />
          <el-table-column label="Customer" min-width="130">
            <template slot-scope="scope">
              <span
                >{{ scope.row.user.firstName }}
                {{ scope.row.user.lastName }}</span
              >
            </template>
          </el-table-column>
          <el-table-column label="Vendor" min-width="130">
            <template slot-scope="scope">
              <span
                >{{ scope.row.vendor.firstName }}
                {{ scope.row.vendor.lastName }}</span
              >
            </template>
          </el-table-column>
          <el-table-column label="Type" min-width="100">
            <template slot-scope="scope">{{
              scope.row.isInward | typeFilter
            }}</template>
          </el-table-column>
          <el-table-column label="Service Req. No." min-width="110">
            <template slot-scope="scope">
              <span v-if="scope.row.serviceRequestNumber">{{
                scope.row.serviceRequestNumber
              }}</span>
            </template>
          </el-table-column>
          <el-table-column label="Status" min-width="110">
            <template slot-scope="scope">
              <span v-if="scope.row.status">
                <el-tag
                  v-if="scope.row.status.code === 'pending'"
                  class="pending-status"
                  effect="dark"
                  >{{ scope.row.status.label }}</el-tag
                >
                <el-tag
                  v-else-if="scope.row.status.code === 'accepted'"
                  type="success"
                  effect="dark"
                  >{{ scope.row.status.label }}</el-tag
                >
                <el-tag
                  v-else-if="scope.row.status.code === 'dispatched'"
                  class="dispatch-status"
                  effect="dark"
                  >{{ scope.row.status.label }}</el-tag
                >
              </span>
            </template>
          </el-table-column>
          <el-table-column label="Actions" width="130">
            <template slot-scope="scope">
              <el-dropdown
                slot="dropdown"
                @command="command => handleAction(scope.row, command)"
              >
                <el-button type="primary" size="mini"> Actions </el-button>
                <el-dropdown-menu
                  slot="dropdown"
                  class="dropdown-menu dropdown-menu-arrow show"
                >
                  <el-dropdown-item command="details"
                    >View Details</el-dropdown-item
                  >
                  <el-dropdown-item command="print">Print</el-dropdown-item>
                  <el-dropdown-item command="showChalan"
                    >Send To WhatsApp</el-dropdown-item
                  >
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>
        <div class="card-footer">
          <div
            v-if="chalanMeta"
            slot="footer"
            class="flex-wrap col-12 d-flex justify-content-center justify-content-sm-between"
          >
            <div class>
              <p class="card-category">
                Showing {{ chalanMeta.from + 1 }} to {{ chalanMeta.to }} of
                {{ chalanMeta.total }} entries
                <span v-if="selectedRows.length"
                  >&nbsp; &nbsp; {{ selectedRows.length }} rows selected</span
                >
              </p>
            </div>
            <pagination :meta="chalanMeta" @paginate="setPagination" />
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      :visible.sync="showChalanModal"
      title="Chalan Invoice"
      width="50%"
    >
      <chalan-design :data="chalanData" @close="showChalanModal = false" />
    </el-dialog>
  </div>
</template>

<script>
import headerComponent from "../Components/HeaderComponent";
import { mapActions, mapState, mapGetters } from "vuex";
import dateFns from "date-fns";
import tableFilter from "../../components/ChalanListFilter.vue";
import pagination from "@/components/AmsaPagination";
import { print } from "@/utils/print";

import {
  Select,
  Option,
  DatePicker,
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
  Dialog,
  Tag,
  Button
} from "element-ui";
import ChalanDesign from "./ChalanDesign.vue";
export default {
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
    [Select.name]: Select,
    [Option.name]: Option,
    [DatePicker.name]: DatePicker,
    [Dialog.name]: Dialog,
    [Tag.name]: Tag,
    [Button.name]: Button,
    pagination,
    "header-component": headerComponent,
    "table-filter": tableFilter,
    "chalan-design": ChalanDesign
  },
  filters: {
    dateFormat(value) {
      return dateFns.format(value, "DD MMM YYYY");
    },
    typeFilter(value) {
      if (value === true) {
        return `Inward`;
      } else {
        return `Outward`;
      }
    }
  },
  data: () => {
    return {
      selectedRows: [],
      pageSize: 10,
      filters: [],
      filterPopUpVisible: false,
      showChalanModal: false,
      chalanData: null
    };
  },
  computed: {
    ...mapState("serviceRequestChalan", ["allChalans", "chalanMeta"]),
    ...mapState("serviceRequestChalan", ["serviceRequestChalan"]),
    ...mapGetters({
      statusList: "status/getStatusList"
    })
  },
  watch: {
    filters: {
      deep: true,
      handler: function(value, oldValue) {
        this.restructureFilters(value);
      }
    }
  },
  mounted() {
    this.getStatusList();
    const data = window.localStorage.getItem("chalanFilters");
    const parsedData = JSON.parse(data);
    if (data != null && parsedData.length != 0) {
      if (parsedData.length > 1) {
        const list = parsedData;
        this.filters.push(...list);
      } else {
        this.filters.push(...parsedData);
      }
    } else {
      this.paginate();
    }
  },
  methods: {
    ...mapActions({
      getAllChalans: "serviceRequestChalan/getAllChalans",
      getStatusList: "status/getStatusList",
      getChalanDetails: "serviceRequestChalan/getServiceRequestChalanDetails",
      printChalan: "serviceRequestChalan/printChalan"
    }),
    async handleAction(row, command) {
      if (command === "details") {
        this.$router.push(`/chalan/${row.serviceRequestChalanId}`);
      } else if (command === "print") {
        await this.handlePrint(row);
      } else {
        this.chalanData = await this.getChalanDetails(
          row.serviceRequestChalanId
        );
        this.showChalanModal = true;
      }
    },

    async handlePrint(row) {
      try {
        // Fetch the complete chalan data using the same API as view details
        const chalanData = await this.getChalanDetails(
          row.serviceRequestChalanId
        );

        const products = chalanData.chalanItems.map(i => {
          return {
            name: i.name,
            quantity: i.quantity,
            price: i.price,
            total: i.amount
          };
        });

        const subTotal = parseFloat(chalanData.total.toFixed(2)) || 0;

        // Prepare the data for printing in the same format as Pos.vue
        const printData = {
          chalanItems: products || [],
          users: chalanData.users || {},
          vendor: chalanData.vendor || {},
          chalanNumber:
            chalanData.chalanNumber || chalanData.serviceRequestChalanId,
          isInward: chalanData.isInward || false,
          total: parseFloat(chalanData.total.toFixed(2)) || 0,
          subTotal: subTotal,
          grandTotal: chalanData.grandTotal || chalanData.total || 0,
          roundedOff:
            parseFloat(chalanData.grandTotal - subTotal).toFixed(2) || 0,
          updatedAt: chalanData.updatedAt || new Date()
        };

        console.log("Print data:", printData);

        // Print the chalan using the same print utility as Pos.vue with type "chalan"
        print(printData, "chalan");

        this.$notify({
          message: "Chalan sent to printer!",
          type: "success",
          title: "Success"
        });
      } catch (error) {
        console.error("Error printing chalan:", error);
        this.$notify({
          message: "Error printing chalan. Please try again.",
          type: "danger",
          title: "Error"
        });
      }
    },

    setPagination(data) {
      this.pageSize = data.perPage;
      this.restructureFilters(this.filters, data.page);
    },
    paginate(page = 1, filters = {}) {
      let query = {
        page,
        perPage: this.pageSize,
        ...filters
      };
      this.getAllChalans(query);
    },
    applyFilters(filters) {
      this.filters.push(filters);
      window.localStorage.setItem(
        "chalanFilters",
        JSON.stringify(this.filters)
      );
      this.filterPopUpVisible = false;
    },
    removeFilter(tagIndex) {
      this.filters.splice(tagIndex, 1);
      if (this.filters.length > 0) {
        window.localStorage.setItem(
          "chalanFilters",
          JSON.stringify(this.filters)
        );
      } else {
        window.localStorage.removeItem("chalanFilters");
      }
    },
    restructureFilters(value, page = 1) {
      const filtered = {};
      value.forEach(i => {
        if (i.field === "date") {
          filtered.fromDate = i.value[0];
          filtered.toDate = i.value[1];
        } else {
          filtered[i.field] = i.value;
        }
      });
      if (Object.entries(filtered).length > 0) {
        this.paginate(page, filtered);
      } else {
        this.paginate(page);
      }
    }
  }
};
</script>

<style>
.pending-status {
  background-color: #e72626;
  border-color: #e72626;
  color: #fff;
}
.dispatch-status {
  background-color: #f57316eb;
  border-color: #f57316eb;
  color: #fff;
}
.table-filters {
  display: inline-block;
}
.table-filters .el-tag {
  margin-left: 10px;
}
</style>
